import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      nav("/admin/dashboard");
    } catch (e2) {
      const msg = formatApiError(e2.response?.data?.detail) || e2.message;
      setErr(msg);
      toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 grid place-items-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-2">
          <img src="/assets/jagaomzet-logo.svg" alt="JagaOmzet" className="w-10 h-10 rounded-xl" />
          <div className="text-left leading-tight">
            <span className="font-extrabold text-xl tracking-tight block">JagaOmzet</span>
            <span className="text-[11px] text-zinc-400 font-medium">Pembeli Balik, Omzet Naik.</span>
          </div>
        </div>
        <div className="bg-white border border-zinc-200 rounded-2xl p-6 sm:p-8 shadow-sm">
          <h1 className="text-2xl font-bold tracking-tight">Masuk Admin</h1>
          <p className="text-sm text-zinc-500 mt-1">Kelola feedback dan pelanggan outlet Anda.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                data-testid="login-email-input" placeholder="admin@jagaomzet.id" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={e => setPassword(e.target.value)}
                data-testid="login-password-input" placeholder="••••••••" />
            </div>
            {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
            <Button type="submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 tap-target"
              data-testid="login-submit-button">
              {loading ? "Memproses..." : "Masuk"}
            </Button>
            <Link to="/forgot-password" className="block text-center text-sm text-zinc-500 hover:text-zinc-900">
              Lupa Password?
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
}
